import { DatasetAccessLevel } from "datasets/types/enums/access-level";
import Dataset from "datasets/types/interfaces/dataset";

// A dataset's "Context" (AI context) tab is available only when the dataset has
// AI agents enabled and the caller has more than preview access — the same gate
// the full dataset page (DatasetDetail) applies to its "Context" nav item.
// Drives the "Context" entry in the session context sidebar
// (SessionContextDatasetDetail).
export const useCanViewDatasetContext = (dataset: Dataset | undefined): boolean => {
  return !!dataset?.aiAgentsEnabled && dataset.access_level !== DatasetAccessLevel.PREVIEW;
};
